import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  detailCont,
  detailHeader,
  detail_hours,
  er_col,
  er_row,
  er_title,
  headers,
  row,
  row_col,
  row_col_hours,
  row_col_staff_type,
  row_col_staff_member,
  row_col_time,
  row_col_map,
  row_main,
  row_title,
  row_value,
  svgAlert,
} from "./row.module.css";
import { f2, text_columns, f25, f3, detail_hours as detailHours, detail as detailCell, detail_row as detailRow, row_col_time as detailTime, detail_map as detailMap } from "./Detail.module.css";

import Detail from "./Detail";
import DetailToggle from "./DetailToggle";
import DisplayHours from "./DisplayHours";
import { useTerminology } from "utils";

const Row = (props) => {
  
  const [open, setOpen] = useState(
    props.hours.ers && props.hours.ers.length ? true : false
  );

  useEffect(() => {
    if (props.expandAll !== undefined) {
      setOpen(props.expandAll);
    }
  }, [props.expandAll]);

  return (
    <div className={row} style={{ paddingRight: props.siteMode ? '0px' : ''}}>
      <div className={row_main}>
        <div className={row_col}>
          <div className={row_title}>Staff member</div>
          <div className={row_value}>{props.staff}</div>
        </div>
        <div className={`${row_col} ${er_col}`}>
          <Errors items={props.hours.ers}></Errors>
        </div>

        <div className={row_col}>&nbsp;</div>
        <div className={row_col}>&nbsp;</div>
        <div className={row_col}>&nbsp;</div>
        
        {props.showGrossHours !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Gross Hours</div>
            <div className={row_value}>
              <DisplayHours hours={Math.round(props.hours.total * 100) / 100} />
            </div>
          </div>
        )}

        {props.showLunch !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Breaks</div>
            <div className={row_value}>
              <DisplayHours hours={props.hours.lunch} />
            </div>
          </div>
        )}

        {props.showNetHours !== false && (
          <div className={row_col_hours}>
            <div className={row_title}>Net Hours</div>
            <div className={row_value}>
              <DisplayHours
                hours={TimeRound(props.hours.total - props.hours.lunch)}
              />
            </div>
          </div>
        )}

        {props.showRounding && (
          <div className={row_col_hours}>
            <div className={row_title}>Rounded</div>
            <div className={row_value}>
              <DisplayHours hours={props.hours.roundedTotal || 0} />
            </div>
          </div>
        )}
      </div>
      <div className={detailCont}>
        <DetailToggle state={open} fn={setOpen}></DetailToggle>
        {open ? <Details records={props.hours.records} showGeolocation={props.showGeolocation} showStaffType={props.showStaffType} showTaskType={props.showTaskType} showEquipment={props.showEquipment} showRounding={props.showRounding} showNotes={props.showNotes} showGrossHours={props.showGrossHours} showLunch={props.showLunch} showNetHours={props.showNetHours} groupByDay={props.groupByDay}></Details> : <div></div>}
      </div>
    </div>
  );
};

const Details = (props) => {
  const { siteLabel } = useTerminology();
  // Group records by calendar date (local), preserving chronological order
  const dayMap = {};
  const dayOrder = [];
  props.records.forEach((record) => {
    const dateKey = moment(record.start, "ddd D MMM YYYY h:mm a").format("YYYY-MM-DD");
    const dateLabel = moment(record.start, "ddd D MMM YYYY h:mm a").format("ddd D MMM YYYY");
    if (!dayMap[dateKey]) {
      dayMap[dateKey] = { label: dateLabel, records: [] };
      dayOrder.push(dateKey);
    }
    dayMap[dateKey].records.push(record);
  });

  return (
    <div>
      <div className={headers}>
        <div className={`${detailHeader} ${row_col_time}`}>Start time</div>
        <div className={`${detailHeader} ${row_col_time}`}>End Time</div>
        <div className={`${detailHeader} ${text_columns}`}>{siteLabel}</div>
        {props.showNotes !== false &&
          <div className={`${detailHeader} ${text_columns}`}>Notes</div>
        }
        {props.showStaffType && 
          <div className={`${detailHeader} ${text_columns}`}>Staff Type</div>
        }
        {props.showTaskType && 
          <div className={`${detailHeader} ${text_columns}`}>Work Type</div>
        }
        {props.showEquipment && 
          <div className={`${detailHeader} ${text_columns}`}>Equipment</div>
        }
        {props.showGeolocation && 
          <div className={`${detailHeader} ${row_col_map}`}>Start Geo</div>
        }
        {props.showGeolocation &&
          <div className={`${detailHeader} ${row_col_map}`}>End Geo</div>
        }
        {props.showGrossHours !== false &&
          <div className={`${detailHeader} ${row_col_hours}`}>Gross Hours</div>
        }
        {props.showLunch !== false &&
          <div className={`${detailHeader} ${row_col_hours}`}>Breaks</div>
        }
        {props.showNetHours !== false &&
          <div className={`${detailHeader} ${row_col_hours}`}>Net Hours</div>
        }
        {props.showRounding &&
          <div className={`${detailHeader} ${row_col_hours}`}>Rounded</div>
        }
      </div>
      {props.groupByDay ? (
        dayOrder.map((dateKey) => {
          const { label, records: dayRecords } = dayMap[dateKey];
          const grossTotal = dayRecords.reduce((sum, r) => sum + r.hours, 0);
          const lunchTotal = dayRecords.reduce((sum, r) => sum + r.lunchAmount, 0);
          const netTotal = grossTotal - lunchTotal;
          const roundedDayTotal = dayRecords.reduce((sum, r) => sum + (r.roundedNetHours || 0), 0);
          return (
            <React.Fragment key={dateKey}>
              <div className={detailRow} style={{
                backgroundColor: "#f0f2f5",
                borderTop: "2px solid #c8cdd6",
                marginTop: "6px",
                fontWeight: 600,
                color: "#1c2b4a",
              }}>
                <div className={`${detailCell} ${detailTime}`} style={{ fontSize: "12px" }}>
                  {label}
                  <span style={{ fontWeight: 400, color: "#888", marginLeft: 6 }}>
                    ({dayRecords.length} {dayRecords.length === 1 ? "entry" : "entries"})
                  </span>
                </div>
                <div className={`${detailCell} ${detailTime}`}></div>
                <div className={`${detailCell} ${text_columns}`}></div>
                {props.showNotes !== false && <div className={`${detailCell} ${text_columns}`}></div>}
                {props.showStaffType && <div className={`${detailCell} ${text_columns}`}></div>}
                {props.showTaskType && <div className={`${detailCell} ${text_columns}`}></div>}
                {props.showEquipment && <div className={`${detailCell} ${text_columns}`}></div>}
                {props.showGeolocation && <div className={`${detailCell} ${detailMap}`}></div>}
                {props.showGeolocation && <div className={`${detailCell} ${detailMap}`}></div>}
                {props.showGrossHours !== false && (
                  <div className={`${detailCell} ${detailHours}`}>
                    <DisplayHours hours={Math.round(grossTotal * 100) / 100} />
                  </div>
                )}
                {props.showLunch !== false && (
                  <div className={`${detailCell} ${detailHours}`}>
                    <DisplayHours hours={Math.round(lunchTotal * 100) / 100} />
                  </div>
                )}
                {props.showNetHours !== false && (
                  <div className={`${detailCell} ${detailHours}`}>
                    <DisplayHours hours={Math.round(netTotal * 100) / 100} />
                  </div>
                )}
                {props.showRounding && (
                  <div className={`${detailCell} ${detailHours}`}>
                    <DisplayHours hours={roundedDayTotal} />
                  </div>
                )}
              </div>
              {dayRecords.map((x, i) => (
                <Detail record={x} key={i} showGeolocation={props.showGeolocation} showStaffType={props.showStaffType} showTaskType={props.showTaskType} showEquipment={props.showEquipment} showRounding={props.showRounding} showNotes={props.showNotes} showGrossHours={props.showGrossHours} showLunch={props.showLunch} showNetHours={props.showNetHours} />
              ))}
            </React.Fragment>
          );
        })
      ) : (
        props.records.map((x, i) => (
          <Detail record={x} key={i} showGeolocation={props.showGeolocation} showStaffType={props.showStaffType} showTaskType={props.showTaskType} showEquipment={props.showEquipment} showRounding={props.showRounding} showNotes={props.showNotes} showGrossHours={props.showGrossHours} showLunch={props.showLunch} showNetHours={props.showNetHours} />
        ))
      )}
    </div>
  );
};

const Errors = (props) => {
  const items = props.items;
  if (!items) {
    return <div></div>;
  }
  return (
    <div>
      {items.map((x, i) => (
        <Error er={x} key={i}></Error>
      ))}
    </div>
  );
};

const Error = ({ er }) => {
  return (
    <div className={er_row}>
      <Icon></Icon>
      <div className={er_title}>{er}</div>
    </div>
  );
};

const TimeRound = (t) => {
  return Math.round(t * 100) / 100;
};

const Icon = () => {
  return (
    <svg
      className={svgAlert}
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#FF1D15"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" />
    </svg>
  );
};

export default Row;
